/*
 * @Descripttion: 快捷拾取弹框hook
 * @Author: cb4786
 * @Date: 2023-09-04 13:16:10
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-30 13:11:42
 */

import { Modal } from 'antd'
import Form, { FormInstance } from 'antd/lib/form'
import { FormFields, State } from '../../hook'
import { imgFile } from '../../../../modules/goodsdetailmodules/uploadimg'
import { useEffect, useReducer, useRef } from 'react'
import {
  POST_SHIBEI_URL_HANDEL,
  ShibeiProductData,
} from '../../../../api/MaterialApi'
import { GetLocalStorage, isResponseCodeSuccess } from '../../../../tools/util'

export interface Props {
  hookstate: State
  form: FormInstance
  closeExtractModal: () => void // 关闭弹框
  onChangePic: (pic: imgFile[]) => void // 修改主图列表
  onChangeDetailPic: (pic: imgFile[]) => void // 修改详情图列表
}

type ActionType =
  | 'setExtractLoadingVisibleAction' // 快捷提取外链状态弹框
  | 'setExtractResultAction' // 快捷提取结果
  | 'setExtractResultTextAction' // 快捷提取结果页文案

interface Action {
  type: ActionType
  payload: any
}
interface ModalState {
  extractLoadingVisible: boolean // 快捷拾取loading状态弹框
  extractResult: boolean // 快捷拾取结果
  extractResultText: string // 快捷拾取报错文案
}
const defaultState: ModalState = {
  extractLoadingVisible: false,
  extractResult: false,
  extractResultText: '',
}
const reducer = (state = defaultState, action: Action): ModalState => {
  const newState = { ...state }
  switch (action.type) {
    case 'setExtractLoadingVisibleAction':
      newState.extractLoadingVisible = action.payload
      return newState
    case 'setExtractResultAction':
      newState.extractResult = action.payload
      return newState
    case 'setExtractResultTextAction':
      newState.extractResultText = action.payload
      return newState
    default:
      return newState
  }
}

// 快捷提取外链loading状态弹框
const setExtractLoadingVisibleAction = (params: boolean): Action => ({
  type: 'setExtractLoadingVisibleAction',
  payload: params,
})

// 快捷提取结果
const setExtractResultAction = (params: boolean): Action => ({
  type: 'setExtractResultAction',
  payload: params,
})

// 快捷提取结果页文案
const setExtractResultTextAction = (params: string): Action => ({
  type: 'setExtractResultTextAction',
  payload: params,
})

const UseSheibeiModalHook = (props: Props) => {
  const { form, hookstate, onChangePic, onChangeDetailPic, closeExtractModal } =
    props
  const { shibeiType, extractVisible, materialType } = hookstate
  const [extractForm] = Form.useForm()
  const loadingStatu = useRef<boolean>()
  const timer = useRef<boolean>()
  const [state, dispatch] = useReducer(reducer, defaultState)

  // 快捷拾取弹框提交按钮
  const handleConfirmExtractModal = () => {
    extractForm
      .validateFields()
      .then(async () => {
        dispatch(setExtractLoadingVisibleAction(true))
        loadingStatu.current = true
        timer.current = true
        // 通过拾贝处理链接接口
        const res = await POST_SHIBEI_URL_HANDEL({
          url: extractForm.getFieldValue('url'),
        })
        if (isResponseCodeSuccess(res.code) && loadingStatu.current) {
          setInitExtractForm({
            ...res.data,
            cateName: form.getFieldValue('cateName'),
            fourthCateMdmId: form.getFieldValue('fourthCateMdmId'),
          })
        } else {
          Modal.destroyAll()
          dispatch(setExtractResultTextAction(res.msg))
          dispatch(setExtractResultAction(true))
        }
      })
      .catch((err) => err)
  }

  // 将链接拾取的信息回填回填
  const setInitExtractForm = (data: ShibeiProductData) => {
    closeLoadingModal()
    closeExtractModal()
    // 修改主要信息
    if (shibeiType !== 'pic') {
      const formdata = formatExtractFormFields(data)
      const param: FormFields = {
        ...formdata,
      }
      form.setFieldsValue(param)
    }
    // 将拾取的主图和详情图回填
    onChangePic(data.picList)
    const list = data.contentUrlList.map((item) => ({
      baseUrl: GetLocalStorage('BASEURL') || '',
      url: item.split(GetLocalStorage('BASEURL'))[1],
      name: '',
    }))
    onChangeDetailPic(list)
  }

  // 快捷拾取的信息替换已填入信息，不匹配字段使用原始值
  const formatExtractFormFields = (formdata: any) => {
    return {
      barCode: formdata.barCode, // 条形码
      name: formdata.name, // 名称
      spec: formdata.manuCode, // 型号规格
      marketprice: formdata.marketPrice, // 市场价
      brandMdmId: formdata.brandId, // 品牌id
      brand: formdata.brandName, // 品牌名称
      // 物料类型为供应商物料时 拾取类目信息
      cateName:
        materialType === '1' ? formdata.categoryName : formdata.cateName, // 所属类目名称
      fourthCateMdmId:
        materialType === '1' ? formdata.categoryId : formdata.fourthCateMdmId, // 类目id
      shiBeiBrandName: formdata.shiBeiBrandName, // 拾取的品牌
      shiBeiCategoryName: formdata.shiBeiCategoryName, // 拾取的类目
    }
  }

  // 拾取中关闭按钮
  const handleCloseResult = () => {
    timer.current = false
    loadingStatu.current = false
    closeLoadingModal()
    closeExtractModal()
  }

  // 快捷拾取弹框关闭按钮
  const handleCancelExtractModal = () => {
    timer.current = false
    closeLoadingModal()
    closeExtractModal()
  }

  // 接口请求失败，点击重试按钮展示url输入弹框
  const reTryShibeiUrlHandel = () => {
    closeLoadingModal()
  }

  // 关闭拾取中及结果页
  const closeLoadingModal = () => {
    dispatch(setExtractResultAction(false))
    dispatch(setExtractLoadingVisibleAction(false))
  }

  useEffect(() => {
    // 每次打开页面情况url数据
    if (extractVisible) {
      extractForm.resetFields()
    }
  }, [extractVisible])

  return {
    state,
    extractForm,
    handleConfirmExtractModal,
    handleCloseResult,
    handleCancelExtractModal,
    reTryShibeiUrlHandel,
  }
}

export default UseSheibeiModalHook
/*
 * @Descripttion: 快捷拾取弹框hook
 * @Author: cb4786
 * @Date: 2023-09-04 13:16:10
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-30 13:11:42
 */

import { Modal } from 'antd'
import Form, { FormInstance } from 'antd/lib/form'
import { FormFields, State } from '../../hook'
import { imgFile } from '../../../../modules/goodsdetailmodules/uploadimg'
import { useEffect, useReducer, useRef } from 'react'
import {
  POST_SHIBEI_URL_HANDEL,
  ShibeiProductData,
} from '../../../../api/MaterialApi'
import { GetLocalStorage, isResponseCodeSuccess } from '../../../../tools/util'

export interface Props {
  hookstate: State
  form: FormInstance
  closeExtractModal: () => void // 关闭弹框
  onChangePic: (pic: imgFile[]) => void // 修改主图列表
  onChangeDetailPic: (pic: imgFile[]) => void // 修改详情图列表
}

type ActionType =
  | 'setExtractLoadingVisibleAction' // 快捷提取外链状态弹框
  | 'setExtractResultAction' // 快捷提取结果
  | 'setExtractResultTextAction' // 快捷提取结果页文案

interface Action {
  type: ActionType
  payload: any
}
interface ModalState {
  extractLoadingVisible: boolean // 快捷拾取loading状态弹框
  extractResult: boolean // 快捷拾取结果
  extractResultText: string // 快捷拾取报错文案
}
const defaultState: ModalState = {
  extractLoadingVisible: false,
  extractResult: false,
  extractResultText: '',
}
const reducer = (state = defaultState, action: Action): ModalState => {
  const newState = { ...state }
  switch (action.type) {
    case 'setExtractLoadingVisibleAction':
      newState.extractLoadingVisible = action.payload
      return newState
    case 'setExtractResultAction':
      newState.extractResult = action.payload
      return newState
    case 'setExtractResultTextAction':
      newState.extractResultText = action.payload
      return newState
    default:
      return newState
  }
}

// 快捷提取外链loading状态弹框
const setExtractLoadingVisibleAction = (params: boolean): Action => ({
  type: 'setExtractLoadingVisibleAction',
  payload: params,
})

// 快捷提取结果
const setExtractResultAction = (params: boolean): Action => ({
  type: 'setExtractResultAction',
  payload: params,
})

// 快捷提取结果页文案
const setExtractResultTextAction = (params: string): Action => ({
  type: 'setExtractResultTextAction',
  payload: params,
})

const UseSheibeiModalHook = (props: Props) => {
  const { form, hookstate, onChangePic, onChangeDetailPic, closeExtractModal } =
    props
  const { shibeiType, extractVisible, materialType } = hookstate
  const [extractForm] = Form.useForm()
  const loadingStatu = useRef<boolean>()
  const timer = useRef<boolean>()
  const [state, dispatch] = useReducer(reducer, defaultState)

  // 快捷拾取弹框提交按钮
  const handleConfirmExtractModal = () => {
    extractForm
      .validateFields()
      .then(async () => {
        dispatch(setExtractLoadingVisibleAction(true))
        loadingStatu.current = true
        timer.current = true
        // 通过拾贝处理链接接口
        const res = await POST_SHIBEI_URL_HANDEL({
          url: extractForm.getFieldValue('url'),
        })
        if (isResponseCodeSuccess(res.code) && loadingStatu.current) {
          setInitExtractForm({
            ...res.data,
            cateName: form.getFieldValue('cateName'),
            fourthCateMdmId: form.getFieldValue('fourthCateMdmId'),
          })
        } else {
          Modal.destroyAll()
          dispatch(setExtractResultTextAction(res.msg))
          dispatch(setExtractResultAction(true))
        }
      })
      .catch((err) => err)
  }

  // 将链接拾取的信息回填回填
  const setInitExtractForm = (data: ShibeiProductData) => {
    closeLoadingModal()
    closeExtractModal()
    // 修改主要信息
    if (shibeiType !== 'pic') {
      const formdata = formatExtractFormFields(data)
      const param: FormFields = {
        ...formdata,
      }
      form.setFieldsValue(param)
    }
    // 将拾取的主图和详情图回填
    onChangePic(data.picList)
    const list = data.contentUrlList.map((item) => ({
      baseUrl: GetLocalStorage('BASEURL') || '',
      url: item.split(GetLocalStorage('BASEURL'))[1],
      name: '',
    }))
    onChangeDetailPic(list)
  }

  // 快捷拾取的信息替换已填入信息，不匹配字段使用原始值
  const formatExtractFormFields = (formdata: any) => {
    return {
      barCode: formdata.barCode, // 条形码
      name: formdata.name, // 名称
      spec: formdata.manuCode, // 型号规格
      marketprice: formdata.marketPrice, // 市场价
      brandMdmId: formdata.brandId, // 品牌id
      brand: formdata.brandName, // 品牌名称
      // 物料类型为供应商物料时 拾取类目信息
      cateName:
        materialType === '1' ? formdata.categoryName : formdata.cateName, // 所属类目名称
      fourthCateMdmId:
        materialType === '1' ? formdata.categoryId : formdata.fourthCateMdmId, // 类目id
      shiBeiBrandName: formdata.shiBeiBrandName, // 拾取的品牌
      shiBeiCategoryName: formdata.shiBeiCategoryName, // 拾取的类目
    }
  }

  // 拾取中关闭按钮
  const handleCloseResult = () => {
    timer.current = false
    loadingStatu.current = false
    closeLoadingModal()
    closeExtractModal()
  }

  // 快捷拾取弹框关闭按钮
  const handleCancelExtractModal = () => {
    timer.current = false
    closeLoadingModal()
    closeExtractModal()
  }

  // 接口请求失败，点击重试按钮展示url输入弹框
  const reTryShibeiUrlHandel = () => {
    closeLoadingModal()
  }

  // 关闭拾取中及结果页
  const closeLoadingModal = () => {
    dispatch(setExtractResultAction(false))
    dispatch(setExtractLoadingVisibleAction(false))
  }

  useEffect(() => {
    // 每次打开页面情况url数据
    if (extractVisible) {
      extractForm.resetFields()
    }
  }, [extractVisible])

  return {
    state,
    extractForm,
    handleConfirmExtractModal,
    handleCloseResult,
    handleCancelExtractModal,
    reTryShibeiUrlHandel,
  }
}

export default UseSheibeiModalHook
